import * as React from "react";
import { useState } from "react";

import { Icon } from "../icons/icon";
import { Typography } from "../typography";

type FaqBlockProps = {
  items: FaqItem[];
  className?: string;
};

type FaqItemsProps = {
  question: string;
  answer: string;
  isOpen: boolean;
  toggle: () => void;
};

type FaqItem = {
  question: string;
  answer: string;
};

const FaqItem = ({ question, answer, isOpen, toggle }: FaqItemsProps) => {
  return (
    <div className="faq-item hover:color-primary w-full cursor-pointer">
      <div className="faq-question flex justify-between py-6" onClick={toggle}>
        <Typography className="body200-regular text-black-primary">
          {question}
        </Typography>
        <Icon primaryColor="black" name={isOpen ? "Minus" : "Plus"} />
      </div>
      {isOpen && (
        <div className="faq-answer pb-4">
          <Typography
            className="body200-regular text-neutral-900"
            dangerouslySetInnerHTML
          >
            {answer}
          </Typography>
        </div>
      )}
    </div>
  );
};

export function FaqBlock({ items, className }: FaqBlockProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaqItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`faq-block flex flex-col items-center ${className ?? ""}`}>
      <p className="body400-medium mr-auto">FAQ</p>
      {items.map((item, index) => (
        <FaqItem
          key={index}
          question={item.question}
          answer={item.answer}
          isOpen={index === openIndex}
          toggle={() => toggleFaqItem(index)}
        />
      ))}
    </div>
  );
}
